/**
 * Supported languages configuration
 * This should match the languages defined in gatsby-config.ts
 */
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'pt'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export enum SupportedLanguages {
  EN = 'en',
  FR = 'fr',
  PT = 'pt'
}

/**
 * Default language
 */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

/**
 * Check if a string is a supported language
 */
export const isSupportedLanguage = (lang: string): lang is SupportedLanguage => {
  return SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);
};
